import { Component, OnInit } from '@angular/core';
import { LoopBackAuth } from '../../../../assets/js/lb-sdk/services';
import { USER_ROLES, PAYMENT_TYPE } from '../../../enums';

@Component({
  selector: 'app-main-left-side',
  templateUrl: './main-left-side.component.html',
  styleUrls: ['./main-left-side.component.css']
})
export class MainLeftSideComponent implements OnInit {
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  PAYMENT_TYPES: typeof PAYMENT_TYPE = PAYMENT_TYPE;

  constructor(private loopBackAuth: LoopBackAuth) { }

  ngOnInit() {

  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  hasPaymentType(type) {
    if (!this.getUser()) {
      return false;
    }
    return (this.getUser().roles || [])
      .filter(role => {
        return role.paymentType === type;
      }).length > 0;
  }
}
